import { render, staticRenderFns } from "./loginWithWeCom.vue?vue&type=template&id=53106b8e&scoped=true&"
import script from "./loginWithWeCom.vue?vue&type=script&lang=ts&"
export * from "./loginWithWeCom.vue?vue&type=script&lang=ts&"
import style0 from "./loginWithWeCom.vue?vue&type=style&index=0&id=53106b8e&prod&lang=scss&scoped=true&"
import style1 from "./loginWithWeCom.vue?vue&type=style&index=1&id=53106b8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53106b8e",
  null
  
)

export default component.exports